export default __webpack_public_path__ + "static/media/barriers-and_bunds.53adbd81.png";